import { css, SerializedStyles } from '@emotion/react';

export const mediaMobile = '@media screen and (max-width: 760px)';
export const mediaDesktop = '@media screen and (min-width: 760px)';

export const mobileMode = (innerCss: SerializedStyles) => css`
  ${mediaMobile} {
    ${innerCss}
  }

  .mobileOnly & {
    ${innerCss}
  }
`;
